import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CementoCotizacionDto } from '../models/cotizacion-cemento.dto';
import { ServerListQuery, ServerPaginatedResponse } from '../models/server-list.model';

@Injectable()
export class CementoCotizacionApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/cotizacion/`;

  listCotizaciones(query: ServerListQuery): Observable<ServerPaginatedResponse<CementoCotizacionDto>> {
    const params = new HttpParams()
      .set('page', String(query.page))
      .set('page_size', String(query.pageSize))
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get<ServerPaginatedResponse<CementoCotizacionDto>>(`${this.baseUrl}list_admin/`, { params });
  }

  closeQuote(orderBuy: string, userId: number): Observable<void> {
    return this.http.post<unknown>(`${this.baseUrl}close_quote/`, { order_buy: orderBuy, user_id: userId }).pipe(map(() => undefined));
  }

  exportExcel(query: ServerListQuery): Observable<Blob> {
    const params = new HttpParams()
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get(`${this.baseUrl}export_excel/`, { params, responseType: 'blob' });
  }

  generatePdf(orderBuy: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}${orderBuy}/pdf/`, { responseType: 'blob' });
  }
}
